import axios from 'axios'

const RESET = 'RESET'
const UPDATE_DATA_SOURCES = 'UPDATE_DATA_SOURCES'
const UPDATE_DATA_SOURCE = 'UPDATE_DATA_SOURCE'

const BASE_URL = 'api/dataSources'
const FETCH_DATA_SOURCES_URL = `${BASE_URL}/`
const FETCH_DATA_SOURCE_URL = (sourceType, id) => `${BASE_URL}/${sourceType}/${id}`
const SET_DS_MF_ID_URL = (sourceType, id) => `${BASE_URL}/${sourceType}/${id}/MFID`
const UNLINK_DS_MF_URL = (sourceType, id) => `${BASE_URL}/${sourceType}/${id}/UNLINK`
const AUTO_ASSIGN_DS_URL = `${BASE_URL}/AutoAssign`

let initialState = () => ({
  dataSources: {},
})

import {
  SOURCE_TYPES,
  SOURCE_TYPES_ON_MAP,
} from './monitoringfeature'

import {
  filterValidLocations,
} from '@/helpers/dataSourceMap'

/* Start Data Source filters */
const ELEMENT_DELIMITER = ','

function makeDSFilterParams(sourceTypes) {
  return {
    sourceTypes: sourceTypes && sourceTypes.join(ELEMENT_DELIMITER),
  }
}
/* End Data Source filters */

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async fetchDataSource({
      commit,
    }, {
      sourceType,
      sourceId,
    }) {
      try {
        let response = await axios.get(FETCH_DATA_SOURCE_URL(sourceType, sourceId))
        let dataSource = response.data
        commit(UPDATE_DATA_SOURCE, {
          sourceType,
          dataSource,
        })
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
    async fetchDataSources({
      commit,
    }, {
      sourceTypes,
    } = {}) {
      try {
        let response = await axios.get(FETCH_DATA_SOURCES_URL, {
          params: {
            ...makeDSFilterParams(sourceTypes),
          },
        })

        let dataSources = response.data
        commit(UPDATE_DATA_SOURCES, dataSources)
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
    async setDSMonitoringFeatureId(_, {
      baseSynonym,
      sourceType,
      sourceId,
      monitoringFeatureId,
      canCompromise,
      shouldMovePrimaryAlias,
      isTestRun,
      makePrimary,
    }) {
      try {
        var response = await axios.post(SET_DS_MF_ID_URL(sourceType, sourceId), {
          baseSynonym,
          monitoringFeatureId,
          canCompromise,
          shouldMovePrimaryAlias,
          isTestRun,
          makePrimary,
        })

        return response.data
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
    async unlinkDSMonitoringFeature(_, {
      baseSynonym,
      sourceType,
      sourceId,
      monitoringFeatureId,
      canCompromise,
      shouldMovePrimaryAlias,
      isTestRun,
      makePrimary,
    }) {
      try {
        var response = await axios.post(UNLINK_DS_MF_URL(sourceType, sourceId), {
          baseSynonym,
          monitoringFeatureId,
          canCompromise,
          shouldMovePrimaryAlias,
          isTestRun,
          makePrimary,
        })

        return response.data
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
    async autoAssignDataSources(_, {
      dataSources,
      createNewLocations,
      isTestRun,
    }) {
      try {
        let response = await axios.post(AUTO_ASSIGN_DS_URL, {
          dataSources,
          createNewLocations,
          isTestRun,
        })

        return response.data
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
  },
  mutations: {
    [UPDATE_DATA_SOURCES](state, dataSources) {
      state.dataSources = {
        ...state.dataSources,
        ...dataSources,
      }
    },
    [UPDATE_DATA_SOURCE](state, {
      sourceType,
      dataSource,
    }) {
      let index = state.dataSources[sourceType].findIndex(ds => ds.Id == dataSource.Id)
      if (index == -1) console.error('Cannot update. Data source not found', dataSource)
      state.dataSources[sourceType].splice(index, 1, dataSource)
    },
    [RESET](state) {
      state.configurations = initialState.configurations
    },
  },
  getters: {
    dataSources: (state) => state.dataSources,
    getDataSourcesGivenMF: (state) => (mf) => state.dataSources[mf],
    dataSourceIndex: (state) => {
      let result = {}

      Object.values(SOURCE_TYPES).forEach(sourceType => {
        let index = {}

        let dataSources = state.dataSources[sourceType]
        if (!dataSources) return
        dataSources.forEach(dataSource => index[dataSource.Id] = dataSource)
        result[sourceType] = index
      })

      return result
    },
    dataSourceIndexByMF: (state) => {
      let index = {}
      Object.values(SOURCE_TYPES).forEach(sourceType => {
        let dataSources = state.dataSources[sourceType]
        if (!dataSources) return

        dataSources.forEach(dataSource => {
          let key = dataSource.MonitoringFeatureId
          if (!index[key]) {
            index[key] = []
          }

          index[key].push(dataSource)
        })
      })
      return index
    },
    dataSourceLocations: (state) => {
      let locations = []

      SOURCE_TYPES_ON_MAP.forEach(sourceType => {
        let dataSources = state.dataSources[sourceType]

        if (!dataSources) return

        let mappedDataSources = dataSources.map(ds => ({
          ...ds,
          SourceType: sourceType,
        }))

        locations.push(...mappedDataSources)
      })

      locations = filterValidLocations(locations)

      return locations
    },
  },
}